import { MAP_BOX_ACCESS_TOKEN } from '@corva/ui/config/mapbox';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line

import { MAPBOX_ENABLED } from '~/externalServices/serviceFlags';

if (MAPBOX_ENABLED) {
  mapboxgl.accessToken = MAP_BOX_ACCESS_TOKEN;
}
